import axios, { InternalAxiosRequestConfig } from 'axios';

export default function setup() {
    axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
        config.withCredentials = true;
        return config;
    });
}
